import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { NgForm } from "@angular/forms/forms";
import { DataServiceProvider } from "../../providers/data-service/data-service";
import { TabsPage } from "../tabs/tabs";
import { SignupPage } from "../signup/signup";


@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {

  login: {username?: string, password?: string} = {};
  submitted = false;
  errorMessage:string = "";

  constructor(
    public navCtrl: NavController, 
    private dataService: DataServiceProvider
  ) {
  }

  onLogin(form: NgForm) {
    this.submitted = true;
    this.errorMessage = "";

    if (form.valid) {
      this.dataService.login(this.login.username,this.login.password).then((data:any) => {
        if(this.navCtrl.canGoBack()){
          this.navCtrl.pop();
        }else{
          this.navCtrl.push(TabsPage);
        }
      })
      .catch((error:any) => {
        console.log("loginerror",error);
        this.errorMessage = error.message;
      })
    }
  }

  onSignup() {
    this.navCtrl.push(SignupPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts